import React from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"
import { DckSelectors, DckActionCreators } from "dck-redux"

import * as ItemTypes from "../../../redux/items/types"
import { browserHistory, Link } from "react-router"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import SingleSelectTable from "../../fragments/SingleSelectTable"
import AlertModal from "../../fragments/AlertModal"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import ClearFiltersButton from "../../fragments/ClearFiltersButton"
import { sortDate } from "../../../lib/utils"
import UIAvatar from "../../fragments/UIAvatar"

class ListAccountingRules extends React.Component {

  authenticated = new Authenticated()
  isAdminOrAccountant = this.authenticated.isAdmin() || this.authenticated.isAccountant()

  state = {
    accountingRule: null,
    running: false,
    success: false,
    error: null,
  }

  componentDidMount() {
    this.props.loadData()
  }

  handleDelete = accountingRule => this.setState({ 
    accountingRule,
    running: false,
    success: false,
    error: null
  })

  confirmDelete = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { accountingRule: { id } } = this.state

    blockingFetchService(
      accessToken => apiServerApi.deleteAccountingRule(accessToken, id),
      _ => {
        this.setState({ success: true })
        this.props.loadData()
        setTimeout(this.closeDeleteForm, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeDeleteForm = () => this.setState({ accountingRule: null })

  doClearFilters = () => {
    this.refs.name.cleanFiltered()
    this.refs.accountToDebitName.cleanFiltered()
    this.refs.accountToCreditName.cleanFiltered()
    this.refs.createdOnFormatted.cleanFiltered()
  }

  renderDeletionConfirmContent = () => {

    const { running, success, error } = this.state
    return (
      <div>
        <h3>Are you sure you want to delete this item?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderUpdateLink = id => {

    if(!this.isAdminOrAccountant) return null
    return (
      <Link to={`/accountingrules/${id}/update`} className='p-5'>
        <FontAwesome name="pencil" title='Update' />
      </Link>
    )
  }

  render() {
    const { accountingrules } = this.props,
    { accountingRule, running } = this.state

    return (
      <div>
        <CustomBreadCrumb activeText='Accounting rules' data={[{ url: '/accounting', title: 'Accounting' }]} />

        <ClearFiltersButton onClick={ this.doClearFilters } />

        <SingleSelectTable
          items={ accountingrules }
          addNewLabel="New Rule"
          addNewHandler={() => browserHistory.push("/accountingrules/create")}
          handleDelete={ this.handleDelete }
          deleteLabel='Delete'
          disableDelete={() => false}
          shouldRenderToolbar={ this.isAdminOrAccountant }
        >
          <TableHeaderColumn
            dataField="id"
            isKey
            dataAlign="center"
            dataFormat={(_, row) => <UIAvatar name={ row.name } size={ 28 } />}
            width='48'
          />

          <TableHeaderColumn
            ref='name'
            dataField="name"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            dataAlign="center"
            columnClassName="min-w-120"
          >
            Name
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='accountToDebitName'
            dataField="accountToDebitName"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            dataAlign="center"
            columnClassName="min-w-120"
          >
            Account to debit
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='accountToCreditName'
            dataField="accountToCreditName"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            dataAlign="center"
            columnClassName="min-w-120"
          >
            Account to credit
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='createdOnFormatted'
            dataField="createdOnFormatted"
            dataAlign="center"
            dataSort
            sortFunc={(a, b, order) => sortDate(a.createdOn, b.createdOn, order)}
            filter={{ type: "DateFilter", delay: 1000 }}
            columnClassName='text-xs'
            width="140px"
          >
            Created On
          </TableHeaderColumn>

          <TableHeaderColumn
            dataAlign="center"
            width="80"
            dataFormat={(_, row) =>
            <span className="flex-detail">
              <Link to={`/accountingrules/${row.id}/detail`} className='p-5'>
                <FontAwesome name="eye" title='View' />
              </Link>
              { this.renderUpdateLink(row.id) }
            </span>}
          />
        </SingleSelectTable>

        <AlertModal
          show={ accountingRule != null }
          title="Confirm deletion"
          body={ this.renderDeletionConfirmContent() }
          bsStyle="danger"
          close={ this.closeDeleteForm }
          confirm={ this.confirmDelete }
          proceedText="Delete"
          disabled={ running }
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const accountingrules = DckSelectors.selectAllItems(state, ItemTypes.AccountingRule)
  return { accountingrules }
},

mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.AccountingRule)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListAccountingRules)



// WEBPACK FOOTER //
// ./src/components/Accounting/AccountingRules/List.js